// extracted by mini-css-extract-plugin
export var copyIcon = "_yr-2";
export var discountCard = "_yr-0";
export var discountCode = "_yr-3";
export var discountContent = "_yr-1";
export var loadingCard = "_yr-4";